/* eslint-disable react/prop-types */
import React from "react";
import {
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import { useStyles } from "./termSheet.style";
import { termSheetList } from "./templateFields";

export const TermSheetHeader = (props) => {
  const classes = useStyles();
  const { termSheetData } = props;

  return (
    <>
      <Grid container item className={classes.headerContainer}>
        <FormControl variant='outlined' style={{ width: "20%" }}>
          <Select
            data-testid='select-term-sheet-dropdown'
            // value={emailInfoObj.sendTo}
            // onChange={handleSendTo}
            defaultValue={termSheetList[0]}
            className={classes.dropdown}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left"
              },
              getContentAnchorEl: null
            }}
          >
            {termSheetList.map((item) => {
              return (
                <MenuItem value={item}>
                  <ListItemText primary={item} />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <Typography style={{ marginLeft: "20px" }}>
          Reviewed By:
          <span style={{ marginLeft: "8px" }}>
            {termSheetData?.reviewedByName}
          </span>
        </Typography>
      </Grid>
      <Grid className={classes.divider} />
    </>
  );
};
